<template>
  <div class="notice">
    <header-bar :name='"图片制作技巧"'></header-bar>

    <!-- <div>
      <span class="back" @click="routerTo('/mpage/m_skill/m_skilllist')">
        <img src="../img/arrow.png" alt="" /> 摄影技巧
      </span>
    </div> -->
    <div class="content">
      <div class="title">图片制作技巧</div>
      <div class="word">
        <div data-v-9f8e8224="">
          <p>
            <strong
              ><span style="font-family: 微软雅黑;font-size: 14px"
                >图片制作小贴士</span
              ></strong
            >
          </p>
          <p style="text-align: center;">
            <img
              src="../img/skill/20210906-1630913500838730.png"
              title="20210906-1630913500838730.png"
              alt="wps14.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              ><span style="font-family:微软雅黑"
                >把照片保存到电脑上，只是照片制作的一个开始，我们应该熟悉一些简单的</span
              ><span style="font-family:微软雅黑"
                >ps技巧。下面就为大家带来几点ps讲解。</span
              ></span
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              >1、首先你需要安装一个Photoshop，然后打开你的Photoshop，点击菜单中“文件”下的“打开”，会弹出一个选择窗口，选中您要ps的图片，照片就会出现在编辑器里。如下图：</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630913511591441.png"
              title="20210906-1630913511591441.png"
              alt="wps15.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              >2、调整图片大小 本次大赛规定上传照片的大小不能超过 5
              MB，怎么让照片变小呢？将鼠标放到图片上方的蓝色边框上点击右键，会弹出一个任务框，选择“图像大小”会显示图片的尺寸，在这里修改成你想要的尺寸就可以了，记住图片尺寸是等比例调整的。如下图：</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630913521394096.png"
              title="20210906-1630913521394096.png"
              alt="wps16.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              ><span style="font-family:微软雅黑"
                >修改好后点击确定就完成了。</span
              ><span style="font-family:微软雅黑"
                ></span
              ></span
            >
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 16px"
              >3、调整图片亮度如果觉得自己的照片拍的比较亮或者暗怎么办？点击菜单里的“图像”选择“调整”，再选择“曲线”，会弹出一个框，通过拖拽框中的曲线可以调整图像的明暗。如下图：</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630913532627735.png"
              title="20210906-1630913532627735.png"
              alt="wps17.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              >4、如果照片拍的模糊，怎么让照片变得清晰一些？可以点击菜单里的“滤镜”选择“锐化”再选择“USM锐化”这样也会弹出一个框，分别有三个可以拖动的按钮分别是数量、半径、阈值。可以通过拖拽这三个拖动条来实现您想要的锐化的效果，如下图:</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630913542522221.png"
              title="20210906-1630913542522221.png"
              alt="wps18.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              >5、保存照片本次大赛规定上传照片的大小不能超过 5
              MB，怎么让照片变小呢？在保存里面也可以实现。点击菜单“文件”选择“储存为Web所用格式”，这时会弹出一个窗口，务必在“预设”中选择“jpg”格式，然后在四个选项中选择小于
              5 MB的图像点击“储存”，您的照片就修好了！如下图：</span
            >
          </p>
          <p style=";text-align:center">
            <img
              src="../img/skill/20210906-1630913553907825.png"
              title="20210906-1630913553907825.png"
              alt="wps19.png"
            />
          </p>
          <p
            style="margin-top: 17px;margin-bottom: 17px;line-height: 23px"
          >
            <span style="font-family: 微软雅黑;font-size: 14px"
              ><span style="font-family:微软雅黑">以上是一些简单的</span
              ><span style="font-family:微软雅黑"
                >ps教程，祝愿您在学习以上技巧后能制作一张完美的作品，并获得大奖！</span
              ></span
            >
          </p>
          <p>
            <strong
              ><span style="font-family: 微软雅黑;font-size: 14px"
                >Acdsee图片制作技巧</span
              ></strong
            >
          </p>
          <p >
            <span style="font-family: 微软雅黑;font-size: 14px"
              ><span style="font-family:微软雅黑"
                >除了使用</span
              ><span style="font-family:微软雅黑"
                >PS，我们可以对单张图片进行调整和修改以外，结合此次征集大赛故事图集的特点，我们如果需要对多张图片进行相关调整也可以用到Acdsee图片批量处理软件，下面我们就来具体学习一下Acdsee的使用方式。</span
              ></span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913567708386.png"
              title="20210906-1630913567708386.png"
              alt="wps20.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >1、acdsee相比于一般的看图软件来说功能要更加的强大，不仅可以用开看图还可以用来分类管理，并且还能编辑图片，我们下载安装acdsee软件以后就在左侧选择图片所在位置，右侧能预览到图片。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913579971489.png"
              title="20210906-1630913579971489.png"
              alt="wps21.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >2、在窗口中我们找到想要查看的图片以后双击就可以打开acdsee图片查看界面，这个和美图看看等软件差不多。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913591966523.png"
              title="20210906-1630913591966523.png"
              alt="wps22.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >3、如果想使用acdsee软件对照片进行编辑我们点击右上角的编辑功能就可以了，acdsee看图软件能够显示图片的尺寸、格式、元数据等等很多信息，所以很多爱好摄影的人都用acdsee看图软件。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913604764030.png"
              title="20210906-1630913604764030.png"
              alt="wps23.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >4、在acdsee编辑图片的界面中我们可以看到很多的功能，比如消除红眼、修复工具、肤色微调等，很多时候acdsee看图软件完全能代替ps对图片来进行处理。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913617846692.png"
              title="20210906-1630913617846692.png"
              alt="wps24.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >5</span
            ><span
              style=";font-family:微软雅黑;font-size:14px"
              ><span style="font-family:微软雅黑">、在</span
              >acdsee软件编辑左侧的几何功能中可以对照片进行旋转、翻转、裁剪、调整大小甚至透视等操作。而在曝光/照明功能中可以调节照片的色阶、曲线等等，堪比photoshop。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913628416641.png"
              title="20210906-1630913628416641.png"
              alt="wps25.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              >6</span
            ><span
              style=";font-family:微软雅黑;font-size:14px"
              ><span style="font-family:微软雅黑">、总之</span
              >acdsee简体中文版功能十分的强大，对于平时管理和处理照片来说都能轻松应对，只要不是特别专业的处理acdsee基本可以替代ps。</span
            >
          </p>
          <p style=";text-align:center;background:rgb(255,255,255)">
            <img
              src="../img/skill/20210906-1630913640403112.png"
              title="20210906-1630913640403112.png"
              alt="wps26.png"
            />
          </p>
          <p style="line-height: 24px;background: rgb(255, 255, 255)">
            <span
              style=";font-family:微软雅黑;font-size:14px"
              ><span style="font-family:微软雅黑">上面就是小编带来的使用</span
              >acdsee进行编辑图片的操作教程，小伙伴们都学会了吗?</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headerBar from './common/headerBar'

export default {
  name: "notice",
  components: {
    headerBar
  },
  data: function() {
    return {};
  },
  methods: {
    routerTo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notice {
  width: 100%;
  margin: 0 auto 0;
  text-align: center;
  font-size: 20px;
  text-align: left;
  .back {
    font-size: 0.36rem;
    color: #0b0b0b;
    font-weight: bold;
    cursor: pointer;
    img {
      vertical-align: middle;
      width: 0.26rem;
      margin-top: -0.1rem;
      margin-left: 0.45rem;
    }
  }
  .content {
    width: calc(100% - 0.9rem);
    background-color: #fff;
    padding: 0 0.45rem 0.6rem;
    box-sizing: border-box;
    margin: 0 0.45rem;
    text-align: center;
    margin-top: 1rem;
    .title {
        position: relative;
        top: -0.45rem;
        width: 40%;
        height: 0.9rem;
        line-height: 0.88rem;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 0.44rem;
        text-align: center;
        font-size: 0.58rem;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -1.1rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/left.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -1.2rem;
          top: 0.2rem;
          content: '';
          display: inline-block;
          width: 0.8rem;
          height: 0.8rem;
          background-image: url(../img/right.png);
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    p {
      text-align: left;
      font-size: 28px;
      color: #0b2ab0;
      line-height: 1.4;
    }
    .p_left {
      text-indent: 0;
    }
    h2 {
      font-size: 28px;
      font-weight: bold;
      color: #0b2ab0;
      text-align: left;
      margin-top: 35px;
    }
    h3 {
      font-size: 28px;
      color: #0b2ab0;
      text-align: left;
      margin-top: 20px;
      text-indent: 1em;
    }
    .word {
      font-size: 16px;
      font-family: 'Microsoft Yahei' !important;
      color: #666;
      line-height: 38px;
      strong {
        font-weight: bold;
      }
      h1,h2,h3,h4,h5,h6 {
        font-weight: bold;
        font-size: 18px;
        margin-bottom: 20px;
      }
      img {
        max-width: 100% !important;
      }
      p {
        line-height: 1.2;
        margin-bottom: 5px;
        color: #0b2ab0;
        word-break: break-all;
        span {
          font-size: 14px;
          font-family: 'Microsoft Yahei';
        }
        a {
          color: #0b2ab0;
        }
        strong {
          font-weight: bold;
        }
        em {
          font-style: italic;
        }
        img {
          max-width: 100% !important;
          text-indent: 0;
          margin-bottom: 0px;
        }
        video {
          margin-left: -2em;
        }
        h1,h2,h3,h4,h5,h6 {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
